import { render, staticRenderFns } from "./IconCalendarEmpty.vue?vue&type=template&id=53c9786b"
import script from "./IconCalendarEmpty.vue?vue&type=script&lang=js"
export * from "./IconCalendarEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports